module.exports = __webpack_public_path__ + "static/bitstamp.c00fc06e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Exchanges/bitstamp.png
// module id = 454
// module chunks = 35783957827783